/**
 * Imports necessary React components and libraries for the current module.
 * @module
 * @requires React
 * @requires useTranslation from "react-i18next"
 * @requires CSmartTable from "@coreui/react-pro"
 * @requires Card from "react-bootstrap/Card"
 * @requires ImportUsers from "./ImportUsers"
 * @requires CustomToggleButton from "../../components/customToggleButton/customToggleButton"
 * @requires Breadcrumbs from "../../components/CustomeBreadcrumb/Breadcrumb"
 * @requires CustomButton from "../../components/customButton/customButton"
 * @requires ConfirmModal from "../../components/confirmModal/confirmModel"
 * @requires EmptyCell from "../../components/emptyCell/emptyCell"
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { CSmartTable } from "@coreui/react-pro";
import { Dropdown } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import ImportUsers from "./importUsers";

import CustomToggleButton from "../../components/customToggleButton/customToggleButton";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import CustomButton from "../../components/customButton/customButton";
import ConfirmModal from "../../components/confirmModal/confirmModel";
import EmptyCell from "../../components/emptyCell/emptyCell";
import SuccessModal from "../../components/successModel/successModel";
import CustomLoadingHTML from "../../components/customLoadingHTML/customLoadingHTML";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Constant from "../../util/constant";
import CustomeDepotGreyBox from "../../components/customeDepotGreyBox/customeDepotGreyBox";

/**
 * A component for managing users.
 * @param {Object} props - The component props.
 * @param {string} props.breadcrumbMainTitle - The main title for the breadcrumb.
 * @param {Function} props.openImportUserModal - Function to open the import user modal.
 * @param {Function} props.handleUserFileUpload - Function to handle user file upload.
 * @param {Function} props.handleClearUploadedUserFile - Function to handle clearing the uploaded user file.
 * @param {string} props.uploadedUserFile - The uploaded user file.
 * @param {boolean} props.showImportUserModal - Flag to show/hide the import user modal.
 * @param {boolean} props.showDeleteUserModal
 */
const UsersManagementComponent = (props) => {
  const { t } = useTranslation();

  /**
   * Destructures the properties object and assigns each property to a corresponding variable.
   * @param {{object}} props - The properties object containing various variables.
   * @returns None
   */
  const {
    breadcrumbMainTitle,
    openImportUserModal,
    handleUserFileUpload,
    handleClearUploadedUserFile,
    uploadedUserFile,
    showImportUserModal,
    showDeleteUserModal,
    onDeleteUser,
    closeImportUserModal,
    columns,
    UserItem,
    itemsPerPage,
    placeHolderShimer,
    onCheckMobile,
    onCheckAction,
    editUserFuction,
    openDeleteUserModal,
    onTableFilterChange,
    noDataFound,
    noDataTitle,
    noDataDesc,
    clearSearchButton,
    tableContainerRef,
    onHide,
    showStatusModal,
    closeDeactiveModal,
    closeDeleteUserModal,
    noDataAddButtonTitle,
    ImportFileSubmit,
    createUserFuction,
    onProcced,
    clearButtonFunction,
    roleOptions,
    depotOptions,
    mobileuserOptions,
    statusOptions,
    smarttableref,
    dimensions,
    headerHeight,
    breadcrumbHeight,
    tableFilterHeight,
    tabHeaderHeight,
    loaderHtml,
    loading,
    loaderButtonShow,
    importModelLoaderBotton,
    disableModelLoaderBotton,
    successModalTitle,
    successModalEmptyRows,
    successModalFailedTotal,
    successModalShow,
    successModalValidRows,
    successModalInvalidRows,
    successModalHandleClose,
    successModalTotal,
    onSelectedItemsChange,
    downLoadButton,
    searchFilterClear,
    searchValue,
    searchedData
  } = props;

  /**
   * Renders a page for user management with various components and functionalities.
   * @returns The JSX elements representing the user management page.
   */

  return (
    <>
      <React.Fragment>
        <div className="page-content usersManagement">
          <Breadcrumbs
            breadcrumbInner={false}
            breadcrumbItem={t("USER_MANAGEMENT")}
            breadcrumbMainTitle={breadcrumbMainTitle}
          />
          <Card
            className={
              loading
                ? "Main_Card Main_Users_Management LoadingTable"
                : "Main_Card Main_Users_Management"
            }
          >
            <Card.Body className="p-0 activeTabSupplier">
              <div className="Main_Card_Body">
                <div className="FormButton_Wrapper">
                  {placeHolderShimer && <CustomeShimer />}

                  {(roleOptions?.length > 0 ||
                    depotOptions?.length > 0 ||
                    mobileuserOptions?.length > 0 ||
                    statusOptions?.length > 0) && (
                    <div className="FilterApply">
                      <p>{t("FILTER_APPLIED")}</p>
                      <button
                        className="clearButton"
                        onClick={clearButtonFunction}
                      >
                        {t("CLEAR_ALL")}
                      </button>
                    </div>
                  )}

                  <CustomButton
                    className="black-btn Border_Button"
                    onClick={() => openImportUserModal()}
                  >
                    {t("IMPORT_USERS")}
                  </CustomButton>
                  <CustomButton
                    className="black-btn Fill_Button"
                    onClick={() => createUserFuction()}
                    loading={loaderButtonShow}
                  >
                    {t("CREATE_USER")}
                  </CustomButton>
                </div>
                <CSmartTable
                  ref={smarttableref}
                  cleaner
                  clickableRows
                  columnSorter={true}
                  items={UserItem}
                  scopedColumns={{
                    fullname: (item) => {
                      const limitedContent = item?.fullname?.slice(0, 150);
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <div className="userDetailsWrapper">
                              <p 
                                className={`${
                                  limitedContent?.length >= 20 && !limitedContent?.includes(' ')
                                  ? 'breakeAll'
                                  : 'wordBrake'
                                }`}>
                                {placeHolderShimer && <CustomeShimer />}
                                {limitedContent}
                              </p>
                            </div>
                          </td>
                        </>
                      );
                    },
                    emailid: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <div className="userDetailsWrapper">
                              <p 
                                className={`${
                                  item?.emailid?.length >= 20 && !item?.emailid?.includes(' ')
                                  ? 'breakeAll'
                                  : 'wordBrake'
                                }`}>
                                {placeHolderShimer && <CustomeShimer />}
                                {item?.emailid}
                              </p>
                            </div>
                          </td>
                        </>
                      );
                    },
                    phone: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <div className="userDetailsWrapper">
                              <p 
                                className={`${
                                  item?.phone?.length >= 10 && !item?.phone?.includes(' ')
                                  ? 'breakeAll'
                                  : 'wordBrake'
                                }`}>
                                {placeHolderShimer && <CustomeShimer />}
                                {item?.phone}
                              </p>
                            </div>
                          </td>
                        </>
                      );
                    },
                    role: (item) => {
                      const limitedContent = item?.role?.slice(0, 150);
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p 
                              className={`${
                                limitedContent?.length >= 20 && !limitedContent?.includes(' ')
                                ? 'breakeAll'
                                : 'wordBrake'
                              }`}>
                              {placeHolderShimer && <CustomeShimer />}
                              {limitedContent}
                            </p>
                          </td>
                        </>
                      );
                    },
                    payno: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p 
                              className={`${
                                item?.payno?.length >= 20 && !item?.payno?.includes(' ')
                                ? 'breakeAll'
                                : 'wordBrake'
                              }`}>
                              {placeHolderShimer && <CustomeShimer />}
                              {item?.payno}
                            </p>
                          </td>
                        </>
                      );
                    },
                    depotname: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p className="counte-depot" >
                              {placeHolderShimer && <CustomeShimer />}
                              {item?.homedepotid ? (
                                <>
                                  <CustomeDepotGreyBox
                                    depotname={item?.homedepotid?.depotname}
                                    homeDepotIcon={true}
                                    className={`${
                                      item?.homedepotid?.depotname?.length >= 20 && !item?.homedepotid?.depotname?.includes(' ')
                                      ? 'breakeAll'
                                      : 'wordBrake'
                                    }`}
                                  />
                                  {item?.homedepotid?.depotname ===
                                  item?.depotname[0]?.depotname ? (
                                    <CustomeDepotGreyBox
                                      className={`${
                                        item?.depotname[1]?.depotname?.length >= 20 && !item?.depotname[1]?.depotname?.includes(' ')
                                        ? 'breakeAll'
                                        : 'wordBrake'
                                      }`}
                                      depotname={item?.depotname[1]?.depotname}
                                    />
                                  ) : (
                                    <CustomeDepotGreyBox
                                      className={`${
                                        item?.depotname[0]?.depotname?.length >= 20 && !item?.depotname[0]?.depotname?.includes(' ')
                                        ? 'breakeAll'
                                        : 'wordBrake'
                                      }`}
                                      depotname={item?.depotname[0]?.depotname}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  {item?.depotname
                                    ?.slice(0, 2)
                                    .map((value, index) => {
                                      return (
                                        <>
                                          <CustomeDepotGreyBox
                                          className={`${
                                            value?.depotname?.length >= 20 && !value?.depotname?.includes(' ')
                                            ? 'breakeAll'
                                            : 'wordBrake'
                                          }`}
                                            depotname={value?.depotname}
                                          />
                                        </>
                                      );
                                    })}
                                </>
                              )}
                              {item?.depotname?.length > 2 && (
                                <CustomeDepotGreyBox
                                  title={item?.depotname
                                    ?.slice(2)
                                    ?.map((valueTilte, valueindex) => {
                                      return valueTilte?.depotname;
                                    })}
                                    className={`${
                                      item?.depotname?.length >= 20 && !item?.depotname?.includes(' ')
                                      ? 'breakeAll'
                                      : 'wordBrake'
                                    }`}
                                  plusShow={true}
                                  depotname={item?.depotname?.length - 2}
                                />
                              )}
                            </p>
                          </td>
                        </>
                      );
                    },
                    allowmobilelogin: (item) => {
                      return (
                        <td
                          className={
                            item?.userstatus ===
                              Constant.GENERALKEYS.INACTIVE && "disableTd"
                          }
                        >
                          <div className="SignrequiredWrapper">
                            {placeHolderShimer && <CustomeShimer />}
                            <CustomToggleButton
                              id={item?._id}
                              checked={item?.allowmobilelogin}
                              onCheckChange={(e) => {
                                item?.role === Constant.GENERALKEYS.DRIVER ? (
                                  <></>
                                ) : (
                                  onCheckMobile(e, item)
                                );
                              }}
                              disabled={item?.role === Constant.GENERALKEYS.DRIVER}
                            />
                            <p>{item?.allowmobilelogin ? "Yes" : "No"}</p>
                          </div>
                        </td>
                      );
                    },
                    userstatus: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.userstatus ===
                                Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p className="StatusCheck">
                              {placeHolderShimer && <CustomeShimer />}
                              <span
                                className={
                                  item?.userstatus ===
                                  Constant.GENERALKEYS.ACTIVE
                                    ? Constant.GENERALKEYS.ACTIVE
                                    : Constant.GENERALKEYS.INACTIVE
                                }
                              >
                                {item?.userstatus ===
                                Constant.GENERALKEYS.ACTIVE
                                  ? Constant.GENERALKEYS.ACTIVE
                                  : "Blocked"}
                              </span>
                            </p>
                          </td>
                        </>
                      );
                    },
                    statusone: (item) => {
                      return (
                        <td
                          className={
                            item?.userstatus ===
                              Constant.GENERALKEYS.INACTIVE && "disableTd"
                          }
                        >
                          <div className="ActionWrapper">
                            {placeHolderShimer && <CustomeShimer />}
                            <CustomToggleButton
                              id=""
                              checked={
                                item?.userstatus === Constant.GENERALKEYS.ACTIVE
                                  ? true
                                  : false
                              }
                              onCheckChange={(e) => {
                                onCheckAction(e, item);
                              }}
                            />
                            <button
                              className="Edit-Buttton"
                              onClick={(e) => {
                                editUserFuction(e, item);
                              }}
                            >
                              <i
                                className="mdi mdi-pencil-outline font-size-24"
                                id="deletetooltip"
                              ></i>
                            </button>
                            <button
                              className="Delete-Buttton"
                              onClick={(e) => {
                                openDeleteUserModal(e, item);
                              }}
                            >
                              <i
                                className="mdi mdi-Delete-outline font-size-24"
                                id="deletetooltip"
                              ></i>
                            </button>
                          </div>
                          <div className="responsive_actionBoxMain">
                            <Dropdown
                              align="end"
                              title="Dropdown end"
                              id="dropdown-menu-align-end"
                            >
                              <Dropdown.Toggle id="dropdown-basic">
                                <i
                                  className="mdi mdi-dots-vertical font-size-24"
                                  id="dropdown-basic"
                                ></i>
                              </Dropdown.Toggle>

                              <Dropdown.Menu x-placement="bottom-start">
                                <Dropdown.Item>
                                  <CustomToggleButton
                                    id=""
                                    checked={
                                      item.status ===
                                      Constant.GENERALKEYS.ACTIVE
                                        ? true
                                        : false
                                    }
                                    onCheckChange={(e) => {
                                      onCheckAction(e, item);
                                    }}
                                  />
                                  Status
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <button
                                    className="Edit-Buttton"
                                    onClick={(e) => {
                                      editUserFuction(e, item);
                                    }}
                                  >
                                    <i
                                      className="mdi mdi-pencil-outline font-size-24"
                                      id="deletetooltip"
                                    ></i>
                                  </button>
                                  {t("EDIT")}
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <button
                                    className="Delete-Buttton"
                                    onClick={openDeleteUserModal}
                                  >
                                    <i
                                      className="mdi mdi-Delete-outline font-size-24"
                                      id="deletetooltip"
                                    ></i>
                                  </button>
                                  {t("DELETE")}
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      );
                    },
                  }}
                  columns={columns}
                  columnFilter
                  onSelectedItemsChange={onSelectedItemsChange}
                  itemsPerPage={itemsPerPage}
                  tableFilter
                  onTableFilterChange={onTableFilterChange}
                  tableFilterLabel={
                    searchValue?.length > 0 && (
                      <button
                        onClick={searchFilterClear}
                        className="btn-close"
                      ></button>
                    )
                  }
                  tableFilterPlaceholder={t("SEARCH_BY_NAME_OR_EMAIL_ADDRESS")}
                  tableProps={{
                    className: UserItem?.length === 0 || searchedData?.length === 0 ? "UserTable emptySearchTable" : "UserTable",
                    responsive: true,
                    striped: false,
                    hover: false,
                  }}
                  noItemsLabel={
                    !placeHolderShimer && (
                      <EmptyCell
                        emptyItems={UserItem}
                        noDataTitle={
                          UserItem?.length === 0 ? noDataFound : noDataTitle
                        }
                        noDataAddButton={true}
                        noDataAddButtonTitle={noDataAddButtonTitle}
                        noDataDesc={noDataDesc}
                        clearSearchButton={clearSearchButton}
                      />
                    )
                  }
                  tableBodyProps={{
                    className: "align-middle Table-Body-scroll",
                    style: {
                      height:
                        dimensions.height -
                        headerHeight -
                        breadcrumbHeight -
                        tableFilterHeight -
                        tabHeaderHeight -
                        (loading && loaderHtml) -
                        100,
                    },
                    ref: tableContainerRef,
                  }}
                ></CSmartTable>
                {loading && <CustomLoadingHTML />}
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
      {/**
       * Renders a ConfirmModal component with the specified props.
       * @param {{string}} className - The class name for the ConfirmModal component.
       * @param {{boolean}} isModelIcon - Determines whether to display an icon in the ConfirmModal component.
       * @param {{function}} onHide - The function to be called when the ConfirmModal is hidden.
       * @param {{string}} iconColor - The color of the icon in the ConfirmModal component.
       * @param {{string}} iconCricle - The class name for the icon circle in the ConfirmModal component.
       * @param {{string}} modalTitle - The title of the ConfirmModal component.
       * @param {{string}} modalDescription - The description of the ConfirmModal component.
       * @
       */}
      {/* Disable Model Message Model */}
      <ConfirmModal
        className={"Deactivate"}
        isModelIcon={true}
        onHide={onHide}
        iconColor={"mdi mdi-toggle-switch-off-outline "}
        iconCricle={"iconCricleDelete"}
        modalTitle={t("DEACTIVATE")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_USER")}
        isUnderline={false}
        showModal={showStatusModal}
        leftBtnTitle={t("YES_DEACTIVATE")}
        isFirstButton={true}
        leftBtnClass={"Deactivate-btn"}
        onProcced={onProcced}
        rightBtnClass="Cancel_Btn"
        isSecondButton={true}
        rightBtnTitle={t("NO_CANCEL")}
        rightButtonClick={closeDeactiveModal}
        loaderButtonShow={disableModelLoaderBotton}
      />
      {/* Delete Message Model */}
      <ConfirmModal
        modalTitle={t("DELETE")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_USER")}
        isUnderline={false}
        showModal={showDeleteUserModal}
        leftBtnTitle={t("YES_DELETE")}
        isModelIcon={true}
        iconColor={"mdi mdi-delete-outline "}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="Cancel_Btn"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onDeleteUser}
        rightButtonClick={closeDeleteUserModal}
      />

      {/* Import user Message Model */}
      <ImportUsers
        showImportUserModal={showImportUserModal}
        closeImportUserModal={closeImportUserModal}
        uploadedUserFile={uploadedUserFile}
        handleUserFileUpload={handleUserFileUpload}
        handleClearUploadedUserFile={handleClearUploadedUserFile}
        ImportFileSubmit={ImportFileSubmit}
        loaderButtonShow={importModelLoaderBotton}
        downLoadButton={downLoadButton}
      />
      {/* Create UserMessage Model */}

      <SuccessModal
        title={successModalTitle}
        total={successModalTotal}
        failedTotal={successModalFailedTotal}
        emptyRows={successModalEmptyRows}
        validRows={successModalValidRows}
        invalidRows={successModalInvalidRows}
        show={successModalShow}
        handleClose={successModalHandleClose}
      />
    </>
  );
};

export default UsersManagementComponent;
